import { useState } from 'react';
import CRM from '../../../services/API/CRM.js';
import { Stack, Alert, TextField, Button} from '@mui/material';
import CategorySelect from '../../Inputs/CategorySelect';
import Toast from '../../Tools/Toast.js';
import { LoadingButton } from '@mui/lab';
import OriginSelect from '../../Inputs/OriginSelect';
import useJsonStore from '../../../services/Hooks/useJsonStore.js';
import { useNavigate } from 'react-router-dom';

export default function Form({id, data, onChange, onCreate}){

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(false);

    const navigate = useNavigate();
    const store = useJsonStore();

    const handleSubmit = e => {
        e.preventDefault();

        (id !== 'new' ? CRM.putProspect(data) : CRM.postProspect(data))
            .then(r => handleSuccess(r.data))
            .catch(e => handleError(e))

        setError(false);
        return setLoading(true);
    }

    const handleSuccess = data => {
        setToast(['success', "Vos modifications ont bien été enregistrées."]);
        setLoading(false);
        return id === 'new' ? onCreate(data) : null;
    }

    const handleError = e => {
        let err;
        if(e.response.status === 409) err = "Un prospect possédant cette adresse email a déjà été créé. Si vous ne le trouvez plus dans la liste des prospects, c'est parce qu'il a été converti en utilisateur.";
        setError(err);
        return setLoading(false);
    }

    const handleTransform = () => {
        store.set('prospectToUser', data);
        return navigate('/crm/persons/new/edit');
    }

    return <>
    
        <form onSubmit={handleSubmit} style={{marginBottom: 20}}>

            <Stack direction='column' width={window.screen.width < 800 ? 320 : 600} spacing={3}>

                {error && <Alert severity='error'>{error}</Alert>}

                <TextField
                    label='Nom'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.lastName || ''}
                    onChange={e => onChange('lastName', e.target.value)}
                />

                <TextField
                    label='Prénom'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.firstName || ''}
                    onChange={e => onChange('firstName', e.target.value)}
                />

                <TextField
                    label='Email'
                    type='email'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.email|| ''}
                    onChange={e => onChange('email', e.target.value)}
                />

                <TextField
                    label='Téléphone'
                    type='tel'
                    value={data.phone || ''}
                    onChange={value => onChange('phone', value)}
                    size='small'
                />

                <TextField
                    label='Motif du contact'
                    inputProps={{maxLength: 250}}
                    size='small'
                    value={data.motive || ''}
                    onChange={e => onChange('motive', e.target.value)}
                />

                <OriginSelect 
                    value={data.origin?.id || ''}
                    onSelect={origin => onChange('origin', origin)}
                />

                <CategorySelect 
                    value={data.category?.id || ''}
                    onChange={id => onChange('category', {id})}
                    required
                />

                <Stack direction='row' justifyContent='flex-end' spacing={2}>

                    {id !== 'new' && 
                        <Button 
                            variant='outlined'
                            onClick={handleTransform}
                        >
                            Basculer en client
                        </Button>
                    }

                    <LoadingButton 
                        type='submit' 
                        loading={loading}
                        variant='contained'
                    >
                        Valider
                    </LoadingButton>
                </Stack>

            </Stack>
                
        </form>


        <Toast 
            open={toast ? true : false}
            severity={toast && toast[0]}
            message={toast && toast[1]}
            onClose={() => setToast(false)}
        />

    </>
}

